<template>
  <div
    :class="$style.root"
    tabindex="0"
  >
    <core-swiper-component>
      <SwiperSlide
        v-for="(entry, key) in items"
        :key="key"
        :class="$style.item"
      >
        <pages-editions-slug-participants-images-participant-thumbnail-component
          :data="entry"
        />
      </SwiperSlide>
    </core-swiper-component>
  </div>
</template>

<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue'

const props = defineProps({
  items: Array
})
</script>

<style module lang="scss">
.root {
  position: relative;
  z-index: calc(var(--z-index--menu) - 1);

  backdrop-filter: var(--backdrop-filter--dark) var(--backdrop-filter--blur);
  margin-bottom: calc(var(--font-small--line-height) * 2);

  --core--swiper--button--margin--horizontal: var(--unit--horizontal);
}

.item {
  position: relative;
}
</style>
